module.exports = __webpack_public_path__ + "static/media/bj.629ec6f6.svg";